module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-repair.svg?h=1b7e1486046a2d10bbad6d501b77e3fe";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-repair.svg
// module id = 2046
// module chunks = 12 15